import CommunicationQuizContainer from './CommunicationQuizContainer';

export default CommunicationQuizContainer;